import React, { ReactElement } from 'react';
import * as Immutable from 'immutable';
import { ConnectedProps, connect } from 'react-redux';
import classNames from 'classnames';

import { getThemeIsDarkMode } from '../../../../../../user/account/accountModal/interface/themeSettings/themeSelector';

import './AiAssistantToolIcon.scss';

const mapStateToProps = (state: Immutable.Map<string, unknown>) => ({
    isDarkMode: getThemeIsDarkMode(state),
});

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
export interface AiAssistantToolIconProps extends PropsFromRedux {
    isDarkMode: boolean;
    isAnimated: boolean;
}

const AiAssistantToolIcon = ({ isDarkMode, isAnimated }: AiAssistantToolIconProps): ReactElement => {
    const imageSource = isDarkMode ? require('./ai-assistant-icon-dark.png') : require('./ai-assistant-icon-light.png');

    const safariVideoSource = isDarkMode
        ? require('./ai-assistant-icon-dark-safari.mov')
        : require('./ai-assistant-icon-light-safari.mov');

    const chromeVideoSource = isDarkMode
        ? require('./ai-assistant-icon-dark-chrome.webm')
        : require('./ai-assistant-icon-light-chrome.webm');

    return (
        <div
            className={classNames('AiAssistantToolIcon', { 'is-animated': isAnimated })}
            key={isDarkMode ? 'video-dark' : 'video-light'}
        >
            {isAnimated ? (
                <video loop muted autoPlay>
                    <source src={safariVideoSource} type='video/mp4; codecs="hvc1"' />
                    <source src={chromeVideoSource} type="video/webm" />
                </video>
            ) : (
                <img src={imageSource} alt="AI Assistant" />
            )}
        </div>
    );
};

export default connect(mapStateToProps)(AiAssistantToolIcon);
